import "./MarketingAssets.css";

import { OrganisationPermissionConstants } from "../../../../constants";
import { Button, Column, Divider, Row } from "../../../../widget";
import { AboutUsForm, AtAGlanceForm, HeroForm, OurServicesForm } from "../../../shared";
import { GetInTouchForm, OurApproachForm, OurValuesForm } from "./forms";
import { useMarketingAssets } from "./useMarketingAssets";

const MarketingAssets = (): JSX.Element => {
  const {
    heroFormRef,
    ourValuesFormRef,
    getInTouchFormRef,
    ourApproachFormRef,
    ourServicesFormRef,
    atAGlanceFormRef,
    aboutUsFormRef,
    dataIsLoading,
    listingRowVersion,
    setListingRowVersion,
    dispatch,
    heroDefaultValues,
    ourValuesDefaultValues,
    getInTouchDefaultValues,
    ourApproachDefaultValues,
    atAGlanceDefaultValues,
    ourServicesDefaultValues,
    aboutUsDefaultValues,
    heroOldDefaultValues,
    ourValuesOldDefaultValues,
    getInTouchOldDefaultValues,
    ourApproachOldDefaultValues,
    atAGlanceOldDefaultValues,
    ourServicesOldDefaultValues,
    aboutUsOldDefaultValues,
    isHandlePreviewLoading,
    handlePreview,
    getCurrentFormsData,
    hasPermission,
    objectUuid,
    objectType,
    objectKey,
    updateListing,
  } = useMarketingAssets();

  return (
    <div>
      {!dataIsLoading && (
        <>
          <Row spacingV="sl" justify="between">
            <Column span={12}>
              <div className="MarketingAssetsContainer">
                <h2>Marketing assets</h2>
                {hasPermission(OrganisationPermissionConstants.WRITE_ORGANISATION) && (
                  <Button text="Preview" onClick={handlePreview} isLoading={isHandlePreviewLoading} />
                )}
              </div>
            </Column>
          </Row>
          {heroDefaultValues && heroOldDefaultValues && (
            <HeroForm
              ref={heroFormRef}
              objectUuid={objectUuid}
              objectType={objectType}
              objectKey={objectKey}
              updateListing={updateListing}
              heroDefaultValues={heroDefaultValues}
              heroOldDefaultValues={heroOldDefaultValues}
              listingRowVersion={listingRowVersion}
              setListingRowVersion={setListingRowVersion}
              dispatch={dispatch}
              getCurrentFormsData={getCurrentFormsData}
            />
          )}

          {ourValuesDefaultValues && ourValuesOldDefaultValues && (
            <>
              <Row spacingV="2xl">
                <Column span={12}>
                  <Divider type="horizontal" />
                </Column>
              </Row>
              <OurValuesForm
                ref={ourValuesFormRef}
                ourValuesDefaultValues={ourValuesDefaultValues}
                ourValuesOldDefaultValues={ourValuesOldDefaultValues}
                listingRowVersion={listingRowVersion}
                setListingRowVersion={setListingRowVersion}
                dispatch={dispatch}
                getCurrentFormsData={getCurrentFormsData}
              />
            </>
          )}

          {getInTouchDefaultValues && getInTouchOldDefaultValues && (
            <>
              <Row spacingV="2xl">
                <Column span={12}>
                  <Divider type="horizontal" />
                </Column>
              </Row>
              <GetInTouchForm
                ref={getInTouchFormRef}
                getInTouchDefaultValues={getInTouchDefaultValues}
                getInTouchOldDefaultValues={getInTouchOldDefaultValues}
                listingRowVersion={listingRowVersion}
                setListingRowVersion={setListingRowVersion}
                dispatch={dispatch}
                getCurrentFormsData={getCurrentFormsData}
              />
            </>
          )}

          {ourApproachDefaultValues && ourApproachOldDefaultValues && (
            <>
              <Row spacingV="2xl">
                <Column span={12}>
                  <Divider type="horizontal" />
                </Column>
              </Row>
              <OurApproachForm
                ref={ourApproachFormRef}
                ourApproachDefaultValues={ourApproachDefaultValues}
                ourApproachOldDefaultValues={ourApproachOldDefaultValues}
                listingRowVersion={listingRowVersion}
                setListingRowVersion={setListingRowVersion}
                dispatch={dispatch}
                getCurrentFormsData={getCurrentFormsData}
              />
            </>
          )}

          {atAGlanceDefaultValues && atAGlanceOldDefaultValues && (
            <>
              <Row spacingV="2xl">
                <Column span={12}>
                  <Divider type="horizontal" />
                </Column>
              </Row>
              <AtAGlanceForm
                ref={atAGlanceFormRef}
                objectUuid={objectUuid}
                objectKey={objectKey}
                updateListing={updateListing}
                atAGlanceDefaultValues={atAGlanceDefaultValues}
                atAGlanceOldDefaultValues={atAGlanceOldDefaultValues}
                listingRowVersion={listingRowVersion}
                setListingRowVersion={setListingRowVersion}
                dispatch={dispatch}
                getCurrentFormsData={getCurrentFormsData}
              />
            </>
          )}

          {ourServicesDefaultValues && ourServicesOldDefaultValues && (
            <>
              <Row spacingV="2xl">
                <Column span={12}>
                  <Divider type="horizontal" />
                </Column>
              </Row>
              <OurServicesForm
                ref={ourServicesFormRef}
                objectUuid={objectUuid}
                objectType={objectType}
                objectKey={objectKey}
                updateListing={updateListing}
                ourServicesDefaultValues={ourServicesDefaultValues}
                ourServicesOldDefaultValues={ourServicesOldDefaultValues}
                listingRowVersion={listingRowVersion}
                setListingRowVersion={setListingRowVersion}
                dispatch={dispatch}
                getCurrentFormsData={getCurrentFormsData}
              />
            </>
          )}

          {aboutUsDefaultValues && aboutUsOldDefaultValues && (
            <>
              <Row spacingV="2xl">
                <Column span={12}>
                  <Divider type="horizontal" />
                </Column>
              </Row>
              <AboutUsForm
                ref={aboutUsFormRef}
                objectUuid={objectUuid}
                objectType={objectType}
                objectKey={objectKey}
                updateListing={updateListing}
                aboutUsDefaultValues={aboutUsDefaultValues}
                aboutUsOldDefaultValues={aboutUsOldDefaultValues}
                listingRowVersion={listingRowVersion}
                setListingRowVersion={setListingRowVersion}
                dispatch={dispatch}
                getCurrentFormsData={getCurrentFormsData}
              />
            </>
          )}
          {/* Temporarily disabling UnsavedChangesModal ENG-664 - by adding false check */}
          {/*  <UnsavedChangesModal
            hasUnsavedChanges={
              false && !previewMode && Object.values(hasUnsavedChanges).some((value) => value === true)
            }
          /> */}
        </>
      )}
    </div>
  );
};

export default MarketingAssets;
